import { Component, OnInit, ViewChild } from '@angular/core';
import { ApplicantDetailsComponent } from '../../../shared/components/applicant-details/applicant-details.component';
import { AddressDetailsComponent } from '../../../shared/components/address-details/address-details.component';
import { PlumberDetailsMfbComponent } from '../../../shared/components/plumber-details-mfb/plumber-details-mfb.component';
import { IppaymentComponent } from '../../../shared/components/ippayment/ippayment.component';
import { LoginService } from '../../../shared/services/login.service';
import { FeeService } from '../../../shared/services/fee.service';
import { MfbService } from '../mfb.service';
import { Router } from '@angular/router';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Steps } from 'primeng/primeng';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import { ApplicationFormBase } from '../../../shared/data-objects/application-form-base';
import { IppaymentService } from '../../../shared/services/ippayment.service';
import { Mfb } from '../mfb';
import { Meta } from '@angular/platform-browser';
import { AddressService } from '../../../shared/services/address.service';
import { PlumberDetails } from '../../../shared/data-objects/plumber-details';
import { RefDataService } from '../../../shared/services/ref-data.service';
import { WorkdetailsMfbComponent } from '../workdetails-mfb/workdetails-mfb.component';
import { WorkrequestMfbDetails } from '../workrequest-mfb-details';
import { environment } from '../../../../app-environments/environment';

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-mfb',
  templateUrl: 'mfb.component.html',
  styleUrls: ['mfb.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, IppaymentComponent, PlumberDetailsMfbComponent, WorkdetailsMfbComponent]
})

export class MfbComponent extends ApplicationFormBase<Mfb> implements OnInit {
  isRequesting: boolean;

  cwwPricingZone: boolean = false;

  plumberDetails: PlumberDetails = new PlumberDetails();
  workdetails: WorkrequestMfbDetails = new WorkrequestMfbDetails();

  termsOfUseUrl: string = '';

  @ViewChild('plumberDetailsMfbComponent') plumberDetailsMfbComponent: PlumberDetailsMfbComponent;
  @ViewChild('workdetailsMfbComponent') workdetailsMfbComponent: WorkdetailsMfbComponent;

  constructor(protected loginService: LoginService, private feeService: FeeService, private addressService: AddressService, private refDataService: RefDataService,
    private mfbService: MfbService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(mfbService, loginService, ipPaymentService, router);
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(4, this._totalOrderAmount);
    });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if (!isTokenValid) {
      if (this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin(async (ok: boolean) => {
          this.retrieveFees();
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.retrieveFees();
      this.setupTabs();
    }
  }

  retrieveFees(): void {
    this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(), this.retrieveFeesOkCb.bind(this));
  }

  setupTabs(): void {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.mfbService.applicationData.applicant);
      this.addMenuItem('Location details', this, 0, 'First Step');
      this.addMenuItem('Work details', this, 1, 'Second Step');
      this.addMenuItem('Plumber details', this, 2, 'Third Step');
      this.addMenuItem('Review and submit', this, 3, 'Fourth Step');
    } else {
      this.setApplicantDetailsForNonBillLater(this.mfbService.applicationData.applicant);
      this.addMenuItem('Location details', this, 0, 'First Step');
      this.addMenuItem('Work details', this, 1, 'Second Step');
      this.addMenuItem('Plumber details', this, 2, 'Third Step');
      this.addMenuItem('Review and submit', this, 3, 'Fourth Step');
      //this.addMenuItem('Payment', this, 4, 'Fifth Step');
    }
  }

  retrieveFeesOkCb(ok: boolean): void {
    if (ok) {
      this.mfb.workrequestDetails = this.mfbService.workrequestDetails;
    } else {
      console.log('no fees found');
    }
  }

  get totalOrderAmount(): number {
    return this.mfbService.workrequestDetails.totalOrderAmount;
  };

  getTotalOrderAmount(): number {
    return this._totalOrderAmount;
  }

  get commitDisabled(): boolean {
    return (!this.mfbService.agreedToTsAndCs ||
      //this.applicant.invalid ||
      this.location.invalid ||
      this.plumberDetailsMfbComponent.invalid ||
      this.workdetailsMfbComponent.invalid
    );
  }

  get mfb(): Mfb {
    return (this.mfbService.applicationData) as Mfb;
  }

  get applicationDate(): string {
    return this.mfbService.applicationDate;
  }

  set applicationDate(v: string) {
    this.mfbService.applicationDate = v;
  }

  set submitErrorMessageWorkRequest(v: string) {
    this.mfbService.submitErrorMessageWorkRequest = v;
  }

  get submitErrorMessageWorkRequest(): string {
    return this.mfbService.submitErrorMessageWorkRequest;
  }

  get _totalOrderAmount(): number {
    return this.mfbService.workrequestDetails.totalOrderAmount;
  }

  set _totalOrderAmount(v: number) {
    this.mfbService.workrequestDetails.totalOrderAmount = v;
  }

  closeModal() {
    this.cwwPricingZone = false;
  }

  notAllowedRegex(input: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbidden = input.test(control.value);
      return forbidden ? {notAllowed: {value: control.value}} : null;
    };
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.mfbService.submitErrorMessage = '';

    this.termsOfUseUrl = this.cwwPricingZone ? environment.termsOfUseURL.CWW : environment.termsOfUseURL.WW;

    if (this.activeIndex === 0) {
      this.addressService.getPricingZone().subscribe(_pricingzone => {
        console.log(_pricingzone.toUpperCase());
        if (_pricingzone && _pricingzone.toUpperCase() === 'FMR CWW') {
          this.cwwPricingZone = true;
          executeNo();
          return;
        } else {
          this.cwwPricingZone = false;
          this.navigateFromLocation(executeYes, executeNo);
        }
      }, err => {
        executeNo();
        return;
      });

    }
    else if (this.activeIndex === 1) {
      this.workdetailsMfbComponent.errorMessage = null;
      if (this.workdetailsMfbComponent.invalid && this.workdetailsMfbComponent.displayErrorMessage().length > 0) {
        this.workdetailsMfbComponent.displayErrorMessage();
        executeNo();
      } else {
        this.workdetailsMfbComponent.errorMessage = '';
        executeYes();
      }
      return;
    }
    else if (this.activeIndex === 2) {
      this.plumberDetailsMfbComponent.errorMessage = null;
      if (this.plumberDetailsMfbComponent.invalid && this.plumberDetailsMfbComponent.displayErrorMessage().length > 0) {
        this.plumberDetailsMfbComponent.displayErrorMessage();
        executeNo();
        return;
      } else {
        this.plumberDetailsMfbComponent.errorMessage = '';
      }

      this.validTermsAndConditions(executeNo, executeYes);
    }
    else if (!this.loginService.isUserBillLater() && this.activeIndex === 3) {
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this._totalOrderAmount, this.submitApplication.bind(this));
    }
    else {
      executeYes();
    }
  }

  canGoPrevious(): boolean {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 0 || this.activeIndex === 4)) {
      return false;
    }

    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goNext(): void {
    if ((this.loginService.isUserBillLater() && this.activeIndex === 3) || (!this.loginService.isUserBillLater() && this.activeIndex === 4)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  submitApplication(callback: any): void {
    let validData = true;
    this.mfbService.submitErrorMessage = '';

    if (this.commitDisabled) {
      this.mfbService.submitErrorMessage = 'Please enter required information before submitting the application.';
      return;
    }
    if (!this.mfbService.agreedToTsAndCs) {
      this.mfbService.submitErrorMessage = 'Please select Terms and Conditions before submitting the application.';
      return;
    }
    this.workdetailsMfbComponent.errorMessage = null;
    if (this.workdetailsMfbComponent.displayErrorMessage().length > 0) {
      this.mfbService.submitErrorMessage += this.workdetailsMfbComponent.displayErrorMessage();
      validData = false;
    }
    // if (this.applicant.displayErrorMessage().length > 0) {
    //   this.mfbService.submitErrorMessage += this.applicant.displayErrorMessage();
    //   validData = false;
    // }

    if (!validData) {
      return;
    }

    this.setApplicantData();
    this.mfbService.applicationData.toUpperCase();
    this.mfbService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.mfbService.applicationData.workrequestDetails = this.workdetailsMfbComponent.workDetails;
    this.mfbService.applicationData.plumberDetails = this.plumberDetailsMfbComponent.plumberDetails;
    this.mfbService.applicationData.consumerNo = this.loginService.getUser().accountNumber;

    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.workdetailsMfbComponent.markValidationControlsAsUntouched();
    //this.plumberDetailsMfbComponent.markValidationControlsAsUntouched();
    //this.feeService.retrieveFees('SimplePlumbing', this.loginService.getToken(), this.retrieveFeesOkCb.bind(this));
  }

  private doSubmit(callback): void {
    this.executeSubmit('mfa', callback, this._totalOrderAmount, null, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/mfb-form/mfb/mfb.component.ts